<template>
  <div class="selection-wrapper">
    <SelectBox v-model.number="selectedDay" :options="days" />
    <SelectBox v-model.number="selectedMonth" :options="months" />
    <SelectBox v-model.number="selectedYear" :options="years" />
  </div>
</template>

<script>
import fill from 'lodash/fill'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

import SelectBox from '@/components/search/SelectBox.vue'

@Component({
  components: {
    SelectBox,
  },
  props: {
    value: {
      type: moment.Moment,
      required: true,
    },
    min: {
      type: moment.Moment,
      required: false,
      default: () => moment().subtract(18, 'years').startOf('day'),
    },
    max: {
      type: moment.Moment,
      required: false,
      default: () => moment().startOf('day'),
    },
  },
})
export default class DateInputWithNativeSelectors extends Vue {
  get days () {
    if (!this.value) return []

    // Month: january=1, february=2, ..., december=12
    // day: 1=1, 2=2, ... 31=31
    const isDaySameOrBeforeMinDate = (year, month, day) => {
      const dayOfMonth = moment().year(year).month(month - 1).date(day)
      return this.min.isSameOrBefore(dayOfMonth, 'day')
    }
    const isDaySameOrAfterMaxDate = (year, month, day) => {
      const dayOfMonth = moment().year(year).month(month - 1).date(day)
      return this.max.isSameOrAfter(dayOfMonth, 'day')
    }

    return fill(new Array(moment(this.value).daysInMonth()), 0)
      .map((empty, day) => day + 1)
      .map(day => ({ value: day, text: day.toString() }))
      .filter(({ value }) => isDaySameOrBeforeMinDate(this.selectedYear, this.selectedMonth, value))
      .filter(({ value }) => isDaySameOrAfterMaxDate(this.selectedYear, this.selectedMonth, value))
  }

  get months () {
    // Month: january=1, february=2, ..., december=12
    const isMonthSameOrBeforeMinDate = (year, month) => {
      const endOfMonth = moment().year(year).month(month - 1)
      return this.min.isSameOrBefore(endOfMonth, 'month')
    }
    const isMonthSameOrAfterMaxDate = (year, month) => {
      const endOfMonth = moment().year(year).month(month - 1)
      return this.max.isSameOrAfter(endOfMonth, 'month')
    }

    return moment.localeData().months()
      .map((name, index) => ({ value: index + 1, text: name.toString() }))
      .filter(({ value }) => isMonthSameOrBeforeMinDate(this.selectedYear, value))
      .filter(({ value }) => isMonthSameOrAfterMaxDate(this.selectedYear, value))
  }

  get years () {
    const result = []
    const timestamp = moment()
    while (this.min.isSameOrBefore(timestamp)) {
      result.push({ value: timestamp.year().toString(), text: timestamp.year() })
      timestamp.subtract(1, 'year')
    }
    return result
  }

  get selectedDay () {
    return this.value.date().toString()
  }

  set selectedDay (value) {
    this.$emit('input', moment(this.value).set('date', value))
  }

  get selectedMonth () {
    return this.value.month() + 1
  }

  set selectedMonth (value) {
    this.$emit('input', moment(this.value).set('month', value - 1))
  }

  get selectedYear () {
    return this.value.year()
  }

  set selectedYear (value) {
    const date = moment(this.value).set('year', value)
    this.$emit('input', date.isSameOrAfter(this.min) ? date : this.min)
  }
}
</script>

<style lang="scss">
.control-content {
  &__birthdays {
    padding-bottom: 20px;
  }
}

.selection-wrapper {
  display: grid;
  grid-template-columns: 65px 1fr 65px;
  grid-column-gap: 10px;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #B9B9B8;
  background-color: transparent;
  text-align: left;
  text-transform: uppercase;
  color: #545454;
  font-size: 15px;
  font-family: 'Gotham';
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/DateInputWithNativeSelectors.vue